"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectTeaser = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _format_amount = require("../helpers/format_amount");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n\tbackground: url(", ");\n  height: 150px;\n  background-size: cover;\n  border-top-right-radius: 3px\n  border-top-left-radius: 3px\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 15px;\n  width: 100%;\n  overflow: hidden;\n  border-bottom-right-radius: ", ";\n  border-bottom-left-radius: ", ";\n\n  > div {\n    width: ", "%;\n    background: ", ";\n    transition: width 0.2s linear;\n    height: 100%;\n    overflow: hidden;\n    border-bottom-right-radius: ", ";\n    border-bottom-left-radius: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: 65px;\n  height: 65px;\n  margin-right: 13px;\n  overflow: hidden;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 22px;\n  padding-left: 13px;\n  width: calc(100% - 100px);\n\n  > div {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    > span {\n      font-weight: bold;\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  flex-grow: 1;\n  margin-bottom: 10px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: 71px;\n  overflow: hidden;\n  padding: 0 13px;\n  font-size: 14px;\n  line-height: 18px;\n  color: #6a6a6a;\n\n  &:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 18px;\n    background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  margin: 10px;\n  font-size: 16px;\n  line-height: 22px;\n  height: 41px;\n  font-weight: bold;\n  overflow: hidden;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  background: white;\n  font-family: ", ";\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  color: ", ";\n  font-weight: 300;\n  height: ", "px;\n  box-sizing: border-box;\n  transition: 0.15s box-shadow ease-out;\n\n  @media (max-width: 767px) {\n    width: 100%;\n  }\n\n  &:hover,\n  &:focus {\n    text-decoration: none;\n    box-shadow: 0 0 10px 0 rgba(0,0,0,0.5);\n    color: inherit;\n\n    h2 {\n      text-decoration: underline;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ProjectTeaser = /*#__PURE__*/function (_React$Component) {
  _inherits(ProjectTeaser, _React$Component);

  var _super = _createSuper(ProjectTeaser);

  function ProjectTeaser() {
    var _this;

    _classCallCheck(this, ProjectTeaser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      _this.props.onClick && _this.props.onClick(event, _this.props.project);
    });

    return _this;
  }

  _createClass(ProjectTeaser, [{
    key: "render",
    value: function render() {
      var project = this.props.project;
      var locale = this.props.locale || document.documentElement.lang || 'de';
      var openAmount = (0, _format_amount.formatAmount)({
        cents: this.props.project.open_amount_in_cents,
        locale: locale
      });
      var donationsCount = new Intl.NumberFormat(locale).format(project.donations_count);
      var openAmountCaption = locale === 'de' ? 'fehlen noch' : 'still needed';
      var donationsCountCaption = locale === 'de' ? 'Spenden' : 'donations';
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        title: project.title,
        onClick: this.handleClick,
        className: this.props.className,
        href: this.href,
        target: this.props.openInTab ? '_blank' : '_parent',
        font: this.props.font,
        textColor: this.props.textColor,
        showDescription: this.props.showDescription,
        extraHeight: this.props.extraHeight
      }, this.props.children
      /* mount point, e.g. for injecting VisibilitySensor */
      ,
      /*#__PURE__*/
      _react["default"].createElement(ProfilePicture, {
        src: this.projectImageUrl,
        alt: project.title
      }), /*#__PURE__*/_react["default"].createElement(Title, {
        dangerouslySetInnerHTML: {
          __html: project.title
        }
      }), this.props.showDescription && /*#__PURE__*/_react["default"].createElement(Description, {
        dangerouslySetInnerHTML: {
          __html: project.description
        }
      }), /*#__PURE__*/_react["default"].createElement(Divider, null, /*#__PURE__*/_react["default"].createElement(FactList, null, /*#__PURE__*/_react["default"].createElement("div", null, project.city && /*#__PURE__*/_react["default"].createElement("span", null, project.city, ", "), project.country), /*#__PURE__*/_react["default"].createElement("div", null, this.props.showCarrierName ? /*#__PURE__*/_react["default"].createElement("span", null, this.props.project.carrier.name) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, donationsCount), " ", donationsCountCaption)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, openAmount), " ", openAmountCaption)), /*#__PURE__*/_react["default"].createElement(CarrierLogo, {
        src: this.orgaImageUrl,
        alt: project.carrier.name
      })), /*#__PURE__*/_react["default"].createElement(Progress, {
        color: this.props.progressbarColor || '#2B8475',
        value: project.progress_percentage,
        backgroundColor: this.props.progressbarBackgroundColor || '#AECFD1',
        borderRadius: this.props.extraHeight ? '0px' : '3px'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "bar"
      })), this.props.bottomContent);
    }
  }, {
    key: "href",
    get: function get() {
      return this.props.href || this.props.project.links.find(function (link) {
        return link.rel === 'platform';
      }).href;
    }
  }, {
    key: "projectImageUrl",
    get: function get() {
      var link = this.props.project.profile_picture.links.find(function (link) {
        return link.rel === 'fill_410x214';
      });
      return link && link.href;
    }
  }, {
    key: "orgaImageUrl",
    get: function get() {
      var link = this.props.project.carrier.picture.links.find(function (link) {
        return link.rel === 'fill_100x100';
      });
      return link && link.href;
    }
  }]);

  return ProjectTeaser;
}(_react["default"].Component);

exports.ProjectTeaser = ProjectTeaser;
ProjectTeaser.propTypes = {
  className: _propTypes["default"].string,
  font: _propTypes["default"].string,
  textColor: _propTypes["default"].string,
  href: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  progressbarColor: _propTypes["default"].string,
  project: _propTypes["default"].object.isRequired,
  showDescription: _propTypes["default"].bool,
  extraHeight: _propTypes["default"].number,
  showCarrierName: _propTypes["default"].bool,
  bottomContent: _propTypes["default"].element
};

var Wrapper = _styledComponents["default"].a(_templateObject(), function (props) {
  return props.font ? props.font : '"Fira Sans", Arial, sans-serif';
}, function (props) {
  return props.textColor ? props.textColor : '#000000';
}, function (props) {
  return (props.showDescription ? 411 : 324) + (props.extraHeight || 0);
});

var Title = _styledComponents["default"].h2(_templateObject2());

var Description = _styledComponents["default"].div(_templateObject3());

var Divider = _styledComponents["default"].div(_templateObject4());

var FactList = _styledComponents["default"].div(_templateObject5());

var CarrierLogo = _styledComponents["default"].img(_templateObject6());

var Progress = _styledComponents["default"].div(_templateObject7(), function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.value;
}, function (props) {
  return props.color;
}, function (props) {
  return props.value > 100 ? props.borderRadius : '0px';
}, function (props) {
  return props.borderRadius;
});

var ProfilePicture = _styledComponents["default"].div(_templateObject8(), function (props) {
  return props.src;
});